import { createContext, useContext, useState } from 'react';
import api from '../api/axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(() => {
    const u = localStorage.getItem('usuario');
    return u ? JSON.parse(u) : null;
  });

  const login = async (login, senha) => {
    const { data } = await api.post('/auth/login', { login, senha });
    localStorage.setItem('token', data.token);
    localStorage.setItem('usuario', JSON.stringify(data.usuario));
    setUsuario(data.usuario);
    return data.usuario;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  // Usado após a troca de senha obrigatória (1º acesso) para limpar a flag sem precisar logar de novo.
  const limparTrocaSenhaObrigatoria = () => {
    setUsuario(u => {
      const atualizado = { ...u, trocarSenhaObrigatoria: false };
      localStorage.setItem('usuario', JSON.stringify(atualizado));
      return atualizado;
    });
  };

  const isSuperAdmin = usuario?.perfil === 'superadmin';
  // Proprietário (dono que também é o mecânico) tem os mesmos acessos do admin,
  // mas com fluxo de OS simplificado (sem etapas de aprovação interna)
  const isProprietario = usuario?.perfil === 'proprietario';
  const isAdmin = usuario?.perfil === 'admin' || isProprietario;

  return (
    <AuthContext.Provider value={{ usuario, login, logout, isAdmin, isSuperAdmin, isProprietario, limparTrocaSenhaObrigatoria }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
